

import { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'
import { LocationNameELDDLAPI } from '../../Redux/DDLSlice'

export const LocationDDL = (props) => {

    const { WardName, LocationName, setLocationName, APIFlag, rowData, Flag, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    // const [workTypeID, setLocationName] = useState('')

    useEffect(() => {
        const data = {
            Flag: APIFlag,
            M_WardID: WardName?.ID,
            M_UserID: UserID,
            token: token
        }
        dispatch(LocationNameELDDLAPI({ data }))
    }, [WardName?.ID, IsPost])

    const { LocationNameData } = useSelector(state => state.LocationNameELDDLData)

    useEffect(() => {
        handleLocationNameDDL()
        console.log('LocationNameData', LocationNameData)
    }, [LocationNameData, IsPost])

    const handleLocationNameDDL = () => {
        if (LocationNameData && LocationNameData.table && LocationNameData.table.length > 0) {
            let list = LocationNameData.table.map((item, index) => ({
                value: item.m_eleC_LocationID,
                label: item.locationName,
            }))
            setLocationName({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_eleC_LocationID : 0,
                Label: Flag === 'Update' ? rowData.locationName : "Select...",
            })
        }
        else {
            setLocationName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label for="" className=""><b>Location Name</b></label>

            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                maxMenuHeight={115}
                value={{ value: LocationName.ID, label: LocationName.Label }}
                onChange={(e) => {
                    e ?
                        setLocationName({ ...LocationName, ID: e.value, Label: e.label })
                        :
                        setLocationName({ ...LocationName, ID: 0, Label: "Select..." })

                }}
                options={LocationName.DDL}
            />
        </div>
    )
}